import Company from '../CompanyComponent.vue'

export default [
    {
        path: '/companies',
        name: '/companies',
        meta: { layout: 'mystagit' },
        component: Company,
    },
]